import { render } from "./ModalCancel.vue?vue&type=template&id=7267a66f"
import script from "./ModalCancel.vue?vue&type=script&lang=js"
export * from "./ModalCancel.vue?vue&type=script&lang=js"

import exportComponent from "/media/dev/Develop/Projects/Sjef/kiosk.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__